module.exports = "paymentMethod: {{transactionPaymentMethod}},\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/Wizard/Snippet/snippets/transactionPaymentMethod.html
// module id = 2159
// module chunks = 0